import { createContext, useContext } from 'react';

export const StorybookContext = createContext({ isStorybook: false });

export const useIsStorybook = () => useContext(StorybookContext);
